module.exports = ".delete-icon{color:aliceblue;margin-left:-50px;font-size:22px;position:absolute;margin-top:-15px;z-index:1000}.scrollable-settings{overflow:auto}@media screen and (max-height: 640px){.logo-margin{margin-left:30px}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/choose-account/choose-account.component.scss
// module id = 781
// module chunks = 0